import { combineReducers } from "redux";

import stamps from "./StampsReducer";

export default combineReducers({
  stamps
});



// WEBPACK FOOTER //
// ./src/reducers/index.js